export default {
    PERSONAL_PROPERTY: 'personal-property',
    SEWER: 'sewer',
    LIABILITY: 'liability',
    FIRE: 'fire',
    WIND_HAIL: 'wind-hail',
    WATER_ICE: 'water-ice',
    WATER_SNOW: 'water-snow',
    WATER_OTHER: 'water-other',
    OTHER: 'other',
};
